module.exports = "\r\n  <!-- Page Content -->\r\n  <router-outlet></router-outlet>\r\n\r\n\r\n  <app-footer></app-footer>\r\n"